const API = process.env.REACT_APP_SERVER_URL;

export const SSO_PARTNER_URL = (process.env.REACT_APP_SSO_PARTNER_URL || '').replace(/\/$/, '');

export function isSsoRoute(pathname) {
  return pathname.startsWith('/sso/');
}

const ALLOWED_RETURN_ORIGINS = new Set([
  typeof window !== 'undefined' ? window.location.origin : '',
  SSO_PARTNER_URL ? new URL(SSO_PARTNER_URL).origin : '',
  'http://localhost:3000',
  'http://localhost:3001',
  'https://berloga.me',
  'https://berloga.pro',
].filter(Boolean));

export function isAllowedReturnUrl(urlString) {
  try {
    return ALLOWED_RETURN_ORIGINS.has(new URL(urlString).origin);
  } catch (_) {
    return false;
  }
}

export function safeNextPath(next) {
  if (!next || typeof next !== 'string') return '/';
  if (!next.startsWith('/') || next.startsWith('//')) return '/';
  return next;
}

/** Переход в другое приложение; если пользователь авторизован — передаём одноразовый SSO-код в URL */
export async function openPartnerApp(path = '/') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (!SSO_PARTNER_URL) {
    console.warn('REACT_APP_SSO_PARTNER_URL не задан');
    return;
  }

  const plainUrl = `${SSO_PARTNER_URL}${normalizedPath}`;
  const token = localStorage.getItem('token');

  if (!token) {
    window.location.href = plainUrl;
    return;
  }

  try {
    const res = await fetch(`${API}/api/auth/sso-code`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => ({}));

    if (res.ok && data?.code) {
      const params = new URLSearchParams({ code: data.code });
      if (normalizedPath !== '/') {
        params.set('next', normalizedPath);
      }
      window.location.href = `${SSO_PARTNER_URL}/sso/callback?${params.toString()}`;
      return;
    }
  } catch (err) {
    console.warn('SSO: не удалось получить код, переход без авторизации', err);
  }

  window.location.href = plainUrl;
}

export function clearSsoAttemptFlag() {
  sessionStorage.removeItem('sso_attempted');
}
